<h1>Toegankelijkheid</h1>

<p>bzconfregistration.azurewebsites.net en bz conferencing app wilen dat iedereen deze website en app kan gebruiken. Komt u toch een pagina tegen die niet toegankelijk is? Dan kunt u dit aan ons melden. </p>

<h2>Wat is een toegankelijke website?</h2>
<p>Een toegankelijke website is voor alle doelgroepen beter te gebruiken. Daarom gelden er functioneel-technische en redactionele toegankelijkheidseisen voor websites van de overheid. Deze zijn vastgelegd in de toegankelijkheidsstandaard Digitoegankelijk EN 301 549.</p>

<h2>Borging van toegankelijkheid</h2>
<p>Wij borgen goede toegankelijkheid door diverse maatregelen binnen onze (dagelijkse) processen.</p>
<ul>
<li>Toegankelijkheid ‘by design’: toegankelijkheid is vanaf de start onderdeel van alle stappen in het ontwerp-, bouw en redactionele proces van deze website.</li>
<li>Onderzoek: onafhankelijke deskundigen toetsen regelmatig (onderdelen van) onze website op toegankelijkheid. Zowel voor de functioneel-technische onderdelen als de redactionele aspecten. Gevonden knelpunten lossen wij duurzaam op.</li>
<li>Kennis medewerkers: onze medewerkers houden hun kennis over toegankelijkheid op peil en passen dit toe waar nodig.</li>
</ul>

<h2>Problemen met toegankelijkheid melden</h2>
<p>Heeft u vragen of opmerkingen? Of wilt u een pagina gebruiken die niet toegankelijk is? Dan kunt u contact opnemen met <a href="mailto:DIO@minbuza.nl">DIO@minbuza.nl</a></p>
 
 


